// extracted by mini-css-extract-plugin
export default {"mainCon":"mainCon--wVTIu","firstScreenCon":"firstScreenCon--ccmJA","areaDetailDrawer":"areaDetailDrawer--SBPue","markerAnimationScale":"markerAnimationScale--LJrDe"};